import React from "react";
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";

import {
  Container,
  Typography,
  Grid,
  Box,
  Card,
  CardContent
} from "@mui/material";

import ArticleIcon from "@mui/icons-material/Article";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";

const About = () => {
  const documents = [
    {
      icon: <EmojiEventsIcon sx={{ fontSize: 40, color: "#5A67D8" }} />,
      title: "ผลงานตีพิมพ์"
    },
    {
      icon: <ArticleIcon sx={{ fontSize: 40, color: "#5A67D8" }} />,
      title: "รายงานวิจัย"
    },
    {
      icon: <HistoryEduIcon sx={{ fontSize: 40, color: "#5A67D8" }} />,
      title: "บทความ / บทสรุปผู้บริหาร"
    },
    {
      icon: <MenuBookIcon sx={{ fontSize: 40, color: "#5A67D8" }} />,
      title: "หนังสือ"
    }
  ];

  const { ref, inView } = useInView({ threshold: 0.2 });

  return (
    <section
      ref={ref}
      id="documents"
      style={{ backgroundColor: "#EEF5FF", padding: "40px 0" }}
    >
      <Container sx={{ textAlign: "center", maxWidth: "md" }}>
        <Typography variant="h5" gutterBottom>
          เอกสารโครงการวิจัย
        </Typography>

        <Grid
          container
          spacing={2}
          justifyContent="center"
          sx={{ display: "flex", flexWrap: "wrap", mt: 3 }}
        >
          {documents.map((documents, index) =>
            <Grid item xs={12} sm={6} md={4} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                transition={{ duration: 0.5, delay: index * 0.2 }}
              >
                <Card
                  elevation={3}
                  sx={{
                    width: "150px", // กำหนดความกว้างให้เท่ากัน
                    height: "130px", // กำหนดความสูงให้เท่ากัน
                    borderRadius: 4,
                    textAlign: "center",
                    padding: 3,
                    backgroundColor: "white",
                    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                    "&:hover": {
                      transform: "scale(1.05)",
                      transition: "transform 0.3s ease-in-out"
                    },
                    cursor: "pointer"
                  }}
                  onClick={() => {
                    if (index === 0) {
                      // ทำอะไรบางอย่างเมื่อ index เท่ากับ 0
                      window.open("/scopus", "_self");
                    } else {
                      // window.open("/doc?order=" + (index + 1), "_self");
                      window.open("/doc?order=" + index, "_self");
                    }
                  }}
                >
                  <Box
                    sx={{
                      width: 70,
                      height: 70,
                      backgroundColor: "#E9EAFB",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 10px"
                    }}
                  >
                    {documents.icon}
                  </Box>
                  <CardContent>
                    <Typography variant="h7" gutterBottom>
                      {documents.title}
                    </Typography>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          )}
        </Grid>
      </Container>
    </section>
  );
};

export default About;
